import React, { useEffect, useState } from "react";
import Loading from "./Loading";
import { fetchAssessmentStatus } from "../services/assessmentApi";

interface ReportData {
  subject: string;
  leftArrowText: string;
  rightArrowText: string;
  bannerColor: string;
  bannerImage: string;
  containerImage: string;
  showLeftArrow: boolean;
  showRightArrow: boolean;
  redirect?: string;
  allocated_subjects?: string[];
  schoolCode?: string; // NEW
  familyCode?: string; // NEW
  login?: string; // NEW
}

interface SubHeaderProps {
  children?: React.ReactNode;
  onDataLoaded?: (data: ReportData) => void;
  isMSRPage?: boolean;
  pageType?: string;
  hideArrows?: boolean;
}

const normalizeSubject = (value: string | null | undefined): string => {
  const subject = value?.trim();
  if (!subject) return "";

  const normalized = subject.toLowerCase();
  if (normalized === "maths" || normalized === "mathematics") return "Mathematics";
  if (normalized === "english" || normalized === "eng") return "English";
  return subject;
};

const SubHeader: React.FC<SubHeaderProps> = ({
  children,
  onDataLoaded,
  isMSRPage = false,
  pageType = "",
  hideArrows = false
}) => {
  const [subjects, setSubjects] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const [loading, setLoading] = useState(true);

  const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK ;
  const storedGrade = sessionStorage.getItem("Grade") || "0";



  /** Check if WLP is assigned (activities.length > 0) */
  // const isWlpAssigned = async (subject: string) => {
  //   try {
  //     const res = await fetch(`${apiUrl}assigned_wlp/`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         SchoolCode: sessionStorage.getItem("SchoolCode"),
  //         FamilyCode: sessionStorage.getItem("FamilyCode"),
  //         Login: sessionStorage.getItem("Login"),
  //         Subject: subject
  //       })
  //     });
  //     const data = await res.json();
  //     return Array.isArray(data?.activities) && data.activities.length > 0;
  //   } catch {
  //     return false;
  //   }
  // };

  // const selectInitialSubject = async () => {
  //   return "Mathematics";
  // };

  const fetchReports = async (subject: string) => {
    const normalizedSubject = normalizeSubject(subject);
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("subject", normalizedSubject);
      params.append("grade_year", storedGrade);
      params.append("country", sessionStorage.getItem("Country") || "");
      params.append("schoolcode", sessionStorage.getItem("SchoolCode") || "");
      params.append("familycode", sessionStorage.getItem("FamilyCode") || "");
      params.append("login", sessionStorage.getItem("Login") || "");
      params.append("page", pageType);


      ["Mathematics", "English", "Science"].forEach((s) =>
        params.append("allocated_subjects", s)
      );

      const res = await fetch(`${apiUrl}msr-reports/?${params.toString()}`);
      const data: ReportData = await res.json();
      if (data.allocated_subjects) {
        setSubjects(data.allocated_subjects);

        const newIndex = data.allocated_subjects.indexOf(data.subject);
        if (newIndex !== -1) setCurrentIndex(newIndex);
      }



      if (data.redirect) {
        window.location.href = data.redirect;
        return;
      }

      const storedSubject = normalizeSubject(data.subject || sessionStorage.getItem("Subject"));
      sessionStorage.setItem("Subject", storedSubject);
      window.dispatchEvent(new Event("subjectChange"));

      if (!isMSRPage) data.bannerImage = data.bannerImage.replace("_report", "");

      // NEW: attach the student identity so parent pages (e.g. MSRReports) can use it
      const enrichedData: ReportData = {
        ...data,
        schoolCode: sessionStorage.getItem("SchoolCode") || undefined,
        familyCode: sessionStorage.getItem("FamilyCode") || undefined,
        login: sessionStorage.getItem("Login") || undefined,
      };

      setReportData(enrichedData);
      onDataLoaded?.(enrichedData);
    } catch (err) {
      console.error("Error fetching report data:", err);
    } finally {
      setLoading(false);
    }
  };

  const getAssessmentPrioritySubject = async (): Promise<string | null> => {
    const schoolCode = sessionStorage.getItem("SchoolCode");
    const familyCode = sessionStorage.getItem("FamilyCode");
    const login = sessionStorage.getItem("Login");

    if (!schoolCode || !familyCode || !login) return null;

    const isReturningFromAssessment =
      new URLSearchParams(window.location.search).get("lastPage") === "Assessment";

    const isActiveAssessment = (status: string) =>
      status === "GET STARTED" || status.includes("RESUME");

    try {
      const [mathsStatus, englishStatus] = await Promise.all([
        fetchAssessmentStatus(
          apiUrl,
          schoolCode,
          familyCode,
          login,
          "Mathematics",
          isReturningFromAssessment
        )
          .then((status) => status.toUpperCase()),
        fetchAssessmentStatus(
          apiUrl,
          schoolCode,
          familyCode,
          login,
          "English",
          isReturningFromAssessment
        )
          .then((status) => status.toUpperCase()),
      ]);

      // Assessments take priority over WLP; Maths Doctor wins if both are active.
      if (isActiveAssessment(mathsStatus)) return "Mathematics";
      if (isActiveAssessment(englishStatus)) return "English";
    } catch (error) {
      console.error("Error loading assessment priorities:", error);
    }

    return null;
  };

  // useEffect(() => {
  //   const load = async () => {
  //     const saved = sessionStorage.getItem("Subject");
  //     // if (saved) return fetchReports(saved);

  //     const res = await fetch(`${apiUrl}assigned_wlp_multisubject/`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         SchoolCode: sessionStorage.getItem("SchoolCode"),
  //         FamilyCode: sessionStorage.getItem("FamilyCode"),
  //         Login: sessionStorage.getItem("Login")
  //       })
  //     });

  //     const wlp = await res.json();

  //     const M = wlp.Mathematics;
  //     const E = wlp.English;

  //     const M_assigned = M.is_wlp_assigned;
  //     const E_assigned = E.is_wlp_assigned;

  //     const M_done = M.completion_percentage === 100;
  //     const E_done = E.completion_percentage === 100;

  //     let initial = "Mathematics";

  //     if (M_assigned && !E_assigned) {
  //       console.error("Plan", M_assigned, E_assigned);
  //       sessionStorage.setItem("Maths_Plan", "Maths Plan");
  //     }
  //     else if (E_assigned && !M_assigned) {
  //       console.error("Plan", M_assigned, E_assigned);
  //       sessionStorage.setItem("English_Plan", "English Plan");
  //     } 
  //     else if (M_assigned && E_assigned) {
  //       console.error("Plan", M_assigned, E_assigned);
  //       sessionStorage.setItem("English_wlp_plan", "English Plan");
  //       sessionStorage.setItem("Maths_wlp_plan", "Maths Plan");
  //     }

  //     if (M_done) {
  //       sessionStorage.setItem("Maths_wlp_status", "C");
  //     }

  //     if (E_done) {
  //       sessionStorage.setItem("English_wlp_status", "C");
  //     }


  //     if (M_assigned && M_done && E_assigned && !E_done) initial = "English";
  //     else if (E_assigned && E_done && M_assigned && !M_done) initial = "Mathematics";

  //     fetchReports(initial);
  //   };

  //   load();
  // }, []);

  useEffect(() => {
    const load = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const requestedSubject = normalizeSubject(searchParams.get("Subject"));
      const isFreshSelectUserEntry =
        searchParams.get("From")?.toLowerCase() === "selectuser" &&
        pageType.toLowerCase() === "studyroom";

      const weeklyPlansPromise = (async () => {
        try {
          const response = await fetch(`${apiUrl}assigned_wlp_multisubject/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              SchoolCode: sessionStorage.getItem("SchoolCode"),
              FamilyCode: sessionStorage.getItem("FamilyCode"),
              Login: sessionStorage.getItem("Login"),
            }),
          });
          const wlp = await response.json();
          const M = wlp.Mathematics;
          const E = wlp.English;

          if (!M || !E) {
            console.error("Mathematics or English missing in API response");
            return null;
          }

          const M_assigned = M.is_wlp_assigned;
          const E_assigned = E.is_wlp_assigned;
          const M_done = M.completion_percentage === 100;
          const E_done = E.completion_percentage === 100;

          if (M_assigned) {
            sessionStorage.setItem("Maths_wlp_plan", "Maths Plan");
          } else {
            sessionStorage.removeItem("Maths_wlp_plan");
          }
          if (E_assigned) {
            sessionStorage.setItem("English_wlp_plan", "English Plan");
          } else {
            sessionStorage.removeItem("English_wlp_plan");
          }
          if (M_done) {
            sessionStorage.setItem("Maths_wlp_status", "C");
          } else {
            sessionStorage.removeItem("Maths_wlp_status");
          }
          if (E_done) {
            sessionStorage.setItem("English_wlp_status", "C");
          } else {
            sessionStorage.removeItem("English_wlp_status");
          }
          window.dispatchEvent(new Event("weeklyPlansUpdated"));

          return { M_assigned, E_assigned, M_done, E_done };
        } catch (error) {
          console.error("Error loading weekly plans:", error);
          return null;
        }
      })();

      // Legacy StudyRoom.aspx honored an explicit Subject query parameter;
      // default/assessment priority only selected a subject when it was absent.
      if (requestedSubject && pageType.toLowerCase() === "studyroom") {
        fetchReports(requestedSubject);
        return;
      }

      if (isFreshSelectUserEntry) {
        try {
          const response = await fetch(`${apiUrl}assigned_wlp/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              SchoolCode: sessionStorage.getItem("SchoolCode"),
              FamilyCode: sessionStorage.getItem("FamilyCode"),
              Login: sessionStorage.getItem("Login"),
              Subject: "Mathematics",
            }),
          });
          const wlp = await response.json();
          if (Array.isArray(wlp?.activities) && wlp.activities.length > 0) {
            fetchReports("Mathematics");
            return;
          }
        } catch (error) {
          console.error("Error checking assigned Maths WLP:", error);
        }
      }

      const prioritySubject =
        pageType.toLowerCase() === "studyroom"
          ? await getAssessmentPrioritySubject()
          : null;

      if (prioritySubject) {
        fetchReports(prioritySubject);
        return;
      }

      if (isFreshSelectUserEntry) {
        try {
          const response = await fetch(`${apiUrl}assigned_wlp/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              SchoolCode: sessionStorage.getItem("SchoolCode"),
              FamilyCode: sessionStorage.getItem("FamilyCode"),
              Login: sessionStorage.getItem("Login"),
              Subject: "English",
            }),
          });
          const wlp = await response.json();
          if (Array.isArray(wlp?.activities) && wlp.activities.length > 0) {
            fetchReports("English");
            return;
          }
        } catch (error) {
          console.error("Error checking assigned English WLP:", error);
        }
      }

      const saved = normalizeSubject(sessionStorage.getItem("Subject"));

      if (saved && pageType.toLowerCase() !== "studyroom") {
        fetchReports(saved);
        return;
      }

      const weeklyPlans = await weeklyPlansPromise;
      if (!weeklyPlans) return;

      const { M_assigned, E_assigned, M_done, E_done } = weeklyPlans;
      let initial = saved === "English" ? "English" : "Mathematics";

      if (!M_assigned && E_assigned) {
        initial = "English";
      } else if (M_assigned && M_done && E_assigned && !E_done) {
        initial = "English";
      } else if (E_assigned && E_done && M_assigned && !M_done) {
        initial = "Mathematics";
      }

      fetchReports(initial);
    };

    load();
  }, []);


  const handleLeftArrowClick = () => {
    if (pageType.toLowerCase() === "mathsdoctor")
      return (window.location.href = "/STUDENT/MSR/UserDiary");

    const prev = (currentIndex - 1 + subjects.length) % subjects.length;
    setCurrentIndex(prev);
    fetchReports(subjects[prev]);
  };

  const handleRightArrowClick = () => {
    if (pageType.toLowerCase() === "mathsdoctor")
      return (window.location.href = "/STUDENT/MSR/StudentActivityReport");

    const next = (currentIndex + 1) % subjects.length;
    setCurrentIndex(next);
    fetchReports(subjects[next]);
  };

  if (loading || !reportData) return <Loading />;

  const hiddenPages = ["mathsdoctor", "userdiary", "studentactivity"];
  const showContainer = !hiddenPages.includes(pageType.toLowerCase());

  return (
    <>
      <div
        className="subject_banner"
        style={{
          backgroundColor: reportData.bannerColor,
          backgroundImage: `url(${reportData.bannerImage})`
        }}
      >



        {!hideArrows && reportData.showLeftArrow && subjects.length > 1 && (
          <div
            className="subject_arrow_left_container"
            onClick={handleLeftArrowClick}
          >
            <div className="subject_arrow_text subject_arrow_text_left">
              <span>{reportData.leftArrowText}</span>
            </div>
            <div className="subject_arrow subject_arrow_left" />
          </div>
        )}

        {!hideArrows && reportData.showRightArrow && subjects.length > 1 && (
          <div
            className="subject_arrow_right_container"
            onClick={handleRightArrowClick}
          >
            <div className="subject_arrow_text subject_arrow_text_right">
              <span>{reportData.rightArrowText}</span>
            </div>
            <div className="subject_arrow subject_arrow_right" />
          </div>
        )}
      </div>

      {showContainer ? (
        <div
          className="subject_container"
          style={{ backgroundImage: `url(${reportData.containerImage})` }}
        >
          {isMSRPage && <div className="subject_top_gap" />}
          {children}
          {isMSRPage && <div className="subject_bottom_gap" />}
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default SubHeader;